import {TimeSeriesService} from 'features/services/timeSeries/services/TimeSeriesService/service';
import {SearchService} from 'features/search/services/SearchService';
import {SearchResult} from 'features/search/types';
import {StageStatus} from 'features/search/filters/enums';
import {getSiteIdForQuery} from 'features/search/helpers';
import {User} from 'features/authentication/models/User';

export interface LastVisitedModel {
    tracking:       string;
    id:             string;
    name:           string;
    stageId:        string;
    areaId:         string;
    municipalityId: string;
    countyId:       string;
    time:           string;
}

export interface MostVisitedModel {
    id:             string;
    name:           string;
    stageId:        string;
    areaId:         string;
    municipalityId: string;
    countyId:       string;
    visits:         number;
}

export class TimeSeriesQueryMethods {
    static async getLastVisited(user?: User | null): Promise<SearchResult[]> {
        const response = await TimeSeriesService.getLastVisited(user);

        if (response && response.data && (response.data as LastVisitedModel[]).length > 0) {
            const lastVisitedData = response.data as LastVisitedModel[];
            const searchResponse = await SearchService.searchByIdsStage(lastVisitedData.map(x => x.id));
            const responseIds = lastVisitedData.map(x => x.id);

            if (searchResponse && searchResponse.data && searchResponse.data.hits.length > 0) {
                const result: SearchResult[] = [];

                searchResponse.data.hits.forEach(function (a) {
                    result[responseIds.indexOf(a.id)] = a;
                });

                return result;
            }
        }

        return [];
    }

    static async getMostVisited(user?: User | null): Promise<SearchResult[]> {
        const response = await TimeSeriesService.getMostVisited(user);

        if (response && response.data) {
            const mostVisitedData = response.data as MostVisitedModel[];
            const counties = mostVisitedData.slice(0, 2).map(x => x.id);

            const stagesResponse = await SearchService.fetchStages({
                filter: {
                    stageStatus: [StageStatus.PLANNED],
                    siteId: getSiteIdForQuery(),
                    tags: counties,
                },
                sort: ['sortOrder:asc'],
            });

            if (stagesResponse && stagesResponse.data && stagesResponse.data.hits) {
                return personalizeByCounty(stagesResponse.data.hits, mostVisitedData);
            }
        }

        return [];
    }
}

function personalizeByCounty(searchResult: SearchResult[], counties: MostVisitedModel[]): SearchResult[] {
    if (!counties) return searchResult;

    const favoriteCounties: Record<string, number> = {};
    counties.forEach(x => favoriteCounties[x.id] = x.visits);
    searchResult.sort((a, b) => {
        const avalue = favoriteCounties[a.county?.id] || 0;
        const bvalue = favoriteCounties[b.county?.id] || 0;
        return bvalue - avalue;
    });

    return searchResult;
}
